import { QueryClient } from '@tanstack/react-query';

/** One cache for the browser session; cleared when the signed-in studio unmounts. */
export const repositoryQueryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false },
  },
});
